
import { Box, Button, Divider, Paper, Stack, TextField, Tooltip, Drawer, Typography, Autocomplete, Modal, Checkbox } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import "../../../Pharmacy/PharmacyPurchase/PharmaPurchase.css"
import { ImagePaths } from '../../../../Utility/ImagePaths';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { CommonGridToolBarWithFilterText, CommonGridToolBarWithFilterTextCustom } from '../../../../Components/Common Components/CommonComponents';
import { formatDate, CheckAccessFunc } from "../../../../Components/CommonFunctions/CommonFunctions";
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { Colors } from '../../../../Styles/Colors';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';

let selectedStatus = ["Active", "Inactive"]
let DisposableStatus = ["Yes", "No"]

let RoleData = null;
let userAccess = null;
class SpecimenMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      specimenData: [],
      DisposableStatus: [],
      containerMasterData: [],
      selectedContainer: {},
      container_name: "",
      selectedSpecimenType: true,
      SpecimenName: "",
      page: 0,
      pageSize: 10,
      rowCount: 0,
      selected_status: "",
      openPopUp: false,
      specimenCode: null,
      disposable_type: '',
      selected_popup_Status : true ,

      order: "",
      shortName: "",
      deptStatus: true,
      disposable: true,
      isFromEdit: false,
      selectedRow: {},
      comments: "",
      selectedId: "",
      selectedStatus: [],
      selectedContainerID: null,
      filteredContainer: {},
      postLoad : false,
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  componentDidMount() {
    RoleData = JSON.parse(localGetItem("loggedInUserInfo"));
    userAccess = CheckAccessFunc("Laboratory", "Settings", "Lab Masters", "Specimen Master", "SubTab")
    this.getSpecimenMasterData()
    this.getContainerMasterData()
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }
  handleValidation = () => {
    if (!this.state.SpecimenName) {
        this.errorMessage("Enter Specimen Name")
        this.setState({postLoad : false})
    } else if (this.state.selected_popup_Status === false && (!this.state.comments) ) {
        this.errorMessage("Enter Inactive Reason")
        this.setState({postLoad : false})
    } else {
        this.postSpecimenMasterData()
    }
}
  postSpecimenMasterData = () => {
    try {
      let status = this.state.selected_status ? true : false
      this.LoaderFunction(true);
      let data = {
        "specimen_name": this.state.SpecimenName ? CommonValidation.removeSpace(this.state.SpecimenName) : "",
        "is_active": this.state.selected_popup_Status,
        "is_disposable": this.state.selectedSpecimenType ? this.state.selectedSpecimenType : false,
        "specimen_code": this.state.specimenCode ? this.state.specimenCode: null,
        "inactive_reason": this.state.comments ? CommonValidation.removeSpace(this.state.comments) :"",
        "id": this.state.selectedId,
        "container_id" : this.state.selectedContainer?.id,
        "container_name" :this.state.selectedContainer?.container_name ? this.state.selectedContainer?.container_name:""
      }
      RestAPIService.create(data, Serviceurls.GET_LAB_SPECIMEN_MASTER).
        then((response) => {
          if (response.data.status === "success") {
            this.successMessage(response?.data?.message)
            this.LoaderFunction(false);
            this.setState({ openPopUp: false, isFromEdit: false, selectedId: null, specimenCode: "", postLoad : false })
            this.handleClear()
            this.getSpecimenMasterData()
          }
          else {
            this.setState({postLoad : false})
            this.LoaderFunction(false);
            this.errorMessage(response?.data?.message)
          }
        }).catch((error) => {
          this.setState({postLoad : false})
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
          this.LoaderFunction(false);
        })
    }
    catch (e) {
      this.setState({postLoad : false})
      this.errorMessage(e.message)
    }
  }
  getContainerMasterData = () => {
    try {
      let status = this.state.selectedStatus ? true : false
      this.LoaderFunction(true);
      RestAPIService.getAll(Serviceurls.GET_LAB_CONTAINER_MASTER).
        then((response) => {
          if (response.data.status === "success") {
            this.LoaderFunction(false);
            this.setState({
              containerMasterData: response?.data?.data ? response?.data?.data  : [] ,
            },()=>{
              let filteredContainer = this.state.containerMasterData?.filter((item)=> (item.is_active))
              this.setState({containerMasterData :filteredContainer})
              })
          }
          else {
            this.LoaderFunction(false);
            this.errorMessage(response?.data?.message)
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
          this.LoaderFunction(false);
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getSpecimenMasterData = () => {
    try {
      let status = this.state.selected_status === "Active" ? true : this.state.selected_status === "Inactive" ? false : ""
      this.LoaderFunction(true);
      RestAPIService.getAll(Serviceurls.GET_LAB_SPECIMEN_MASTER + `?is_disposable=${this.state.disposable_type === "Yes" ? true : this.state.disposable_type === "No" ? false : ""}&specimen_name=${this.state.SelectSpecimen ? this.state.SelectSpecimen : ""}&container_id=${this.state.filteredContainer?.id ? this.state.filteredContainer?.id : ""}&is_active=${status}`).
        then((response) => {
          if (response.data.status === "success") {
            this.LoaderFunction(false);

            this.setState({
              specimenData: response.data.data ? response.data.data : []
            })
          }
          else {
            this.LoaderFunction(false);
            this.errorMessage(response?.data?.message)
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
          this.LoaderFunction(false);
        })
    }
    catch (e) {
      this.errorMessage(e?.message)
    }
  }
  closeFilter = () => {
    this.setState({ FilterOpen: false })
  }
  handleClear = () => {
    this.setState({
      SpecimenName: "",
      selectedSpecimenType: true,
      shortName: "",
      selectedContainer: {},
      comments: "",
      disposable: true,
      selected_popup_Status: true,
    })
  }

  renderFilterScreen = () => {
    const { t } = this.props;
    let states = this.state;
    return (
      <Box component={"div"} className='eMed_rts_filter_container'>
        <Box component={"div"} className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>{t('Filter')}</Typography>
          <Button emed_tid="vnd_close" onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
          </Button>
        </Box>
        <Box className='eMed_rts_middle'>
          <Box className='eMed_rts_dropdown'>
            <TextField
              label={t("Search Specimen")}
              sx={{ width: "20vw" }}
              size="small"
              autoComplete="off"
              value={states.SelectSpecimen ? states.SelectSpecimen : ""}
              inputProps={{ emed_tid: "VendorName",maxLength:100 }}
              onChange={(e) => {
                this.setState({
                  SelectSpecimen: e.target.value.trimStart()
                })
              }}
            />
          </Box>
          <Box className='eMed_rts_dropdown'>
            <Autocomplete
              size='small'
              sx={{ width: "20vw" }}
              disableClearable
              options={this.state.containerMasterData}
              getOptionLabel={(options) => typeof (options) === 'string' ? options : options?.container_name}
              value={this.state.filteredContainer?.container_name ? this.state.filteredContainer : null}
              onChange={(event, newValue) => {
                this.setState({ filteredContainer: newValue })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputProps={{ ...params.inputProps, 'emed_tid': 'concession_Type_TestID', }}
                  label={('Select container')}
                  autoComplete='off'
                />
              )}
            />
          </Box>
          <Box className='eMed_rts_dropdown'>
            <Autocomplete
              size='small'
              sx={{ width: "20vw" }}
              disableClearable
              options={DisposableStatus}
              // getOptionLabel={(option) => (option)}
              getOptionLabel={(options) => typeof (options) === 'string' ? options : options?.container_name}
              value={this.state.disposable_type}
              onChange={(event, newValue) => {
                this.setState({ disposable_type: newValue })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputProps={{ ...params.inputProps, 'emed_tid': 'concession_Type_TestID', }}
                  label={t('Disposable Type')}
                  autoComplete='off'
                />
              )}
            />
          </Box>
          <Box className='eMed_rts_dropdown'>
            <Autocomplete
              size='small'
              sx={{ width: "20vw" }}
              disableClearable
              options={selectedStatus}
              getOptionLabel={(option) => (option)}
              value={this.state.selected_status}
              onChange={(event, newValue) => {
                this.setState({ selected_status: newValue })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputProps={{ ...params.inputProps, 'emed_tid': 'concession_Type_TestID', }}
                  label={t('Select Status')}
                  autoComplete='off'
                />
              )}
            />
          </Box>
        </Box>
        <Stack spacing={2} direction="row" className='eMed_rts_btn' alignItems="center" justifyContent="center">
          <Button variant='outlined' size="small" emed_tid="fil_clear"
            onClick={() => {
              this.setState({             
                SelectSpecimen: '',
                filteredContainer: {},
                disposable_type: '',
                selected_status: ''
              }, () => this.getSpecimenMasterData())
            }}
            id="eMed_Config_btn">{t("Clear")}</Button>
          <Button variant='contained' size="small" emed_tid="fil_search"
            onClick={() => {
              this.getSpecimenMasterData()
              this.setState({ FilterOpen: false })
            }}
            id="eMed_Config_btn">{t("Search")}</Button>
        </Stack>
      </Box>
    )
  }

  handleEdit = (data) => {
    let containerData = this.state.containerMasterData?.find((item) => item.id === data.container_id)
    this.setState({
      isFromEdit: true,
      openPopUp: true,
      specimenCode: data?.specimen_code,
      SpecimenName: data?.specimen_name,
      selectedSpecimenType: data?.is_disposable,
      shortName: data?.short_name,
      selectedId: data?.id,
      selectedContainer: containerData ? containerData : {},
      comments: data?.inactive_reason,
      disposable: data?.is_disposable,
      selected_popup_Status: data?.is_active
    })

  }
  renderTextField = (value, statekey, Label, required, width, disable = false) => {
    const { t } = this.props;
    let states = this.state
    return (
      <TextField
        sx={{ width: width ? width : "12vw", marginX: '0.65vw', marginTop: "1vw" }}
        size="small"
        disabled={disable}
        inputProps={{ maxLength: statekey === "order" ? 3 : 100 }}
        autoComplete="off"
        label={t(Label)}
        required={required}
        value={value}
        onChange={(e) => {
          let value = e.target.value
          if (statekey === "order") {
            if (CommonValidation.numberOnly(value) || value === "") {
              states[statekey] = value.trimStart()
              this.setState({ states })
            }
          } else {
            states[statekey] = value.trimStart()
            this.setState({ states })
          }

        }}
      />
    )
  }
  addNewDepartPopup = () => {
    let states = this.state
    return (
      <div>
        <Modal open={this.state.openPopUp}>

          <Box component={"div"} className='eMed_Doc_Notes_Counsellor_Pop_Up' style={{ padding: "1vw", width: "42vw", height: "64vh", maxHeight: "100%", display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <Box  >
              <Box component={'div'} p={'0.5vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{states.isFromEdit ? "Edit Specimen" : "Add Specimen"}</Typography>
                <Button className='Common_Btn_Min_Width' onClick={() => this.setState({ openPopUp: false, isFromEdit: false, selectedId: null, specimenCode : ''}, () => { this.handleClear() })} >
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                </Button>
              </Box>
              <hr />
              <Box component={'div'} style={{ display: "flex", flexDirection: "row" }}>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                  <Box  >
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                      {this.state.isFromEdit ? this.renderTextField(this.state.specimenCode, "specimenCode", "Specimen Code", true, "12vw", true) : null}
                      {this.renderTextField(this.state.SpecimenName, "SpecimenName", "Specimen Name", true, !this.state.isFromEdit ? "18.5vw" :"12vw")}
                      {/* {this.renderTextField(this.state.order, "order", "Order", true, "12vw")} */}
                      <Box sx={{ marginTop: "1vw" }}>
                        <Autocomplete
                          size='small'
                          sx={{ width: !this.state.isFromEdit ? "18.5vw" :"12vw" }}
                          disableClearable
                          options={this.state.containerMasterData}
                          // getOptionLabel={(option) => (option)}
                          getOptionLabel={(options) => typeof (options) === 'string' ? options : options?.container_name}
                          value={this.state.selectedContainer?.container_name ? this.state.selectedContainer : null}
                          onChange={(event, newValue) => {
                            this.setState({ selectedContainer: newValue, selectedContainerID :newValue.id })
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              inputProps={{ ...params.inputProps, 'emed_tid': 'concession_Type_TestID', }}
                              label={('Select Container')}
                              autoComplete='off'
                            />
                          )}
                        />
                      </Box>
                    </div>
                  </Box>
                </Box>
              </Box>
              {
                <Box component={'div'} style={{ display: "flex", flexDirection: "column" }}>
                  <Box sx={{ marginLeft: "1vh", marginTop: "1vh" }}>
                    <Typography>{"Specimen Type"}</Typography>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                    <Checkbox
                      checked={this.state.selectedSpecimenType}
                      onChange={(e) => { this.setState({ selectedSpecimenType: e.target.checked }) }}
                    />
                    <Typography>{"Disposable"}</Typography>
                  </Box>
                </Box>}

              {
                <Box component={'div'} style={{ display: "flex", flexDirection: "column" }}>
                  <Box sx={{ marginLeft: "1vh", marginTop: "1vh" }}>
                    <Typography>{"Status"}</Typography>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                    <Checkbox
                      checked={this.state.selected_popup_Status}
                      disabled ={!this.state.isFromEdit}
                      onChange={(e) => { this.setState({ selected_popup_Status: e.target.checked , comments :"" }) }}
                    />
                    <Typography>{"Active"}</Typography>
                  </Box>
                </Box>}
              {this.state.selected_popup_Status === false ?
                <Box>
                  <Box sx={{ marginLeft: "1vh", marginTop: "1vh" }}>
                    <Typography>{"Inactive Comments"}</Typography>
                  </Box>
                  <Box sx={{ marginLeft: "1vh", marginTop: "1vh" }}>
                    <div>
                      <TextField
                        size='small'
                        label={("Reason *")}
                        inputProps={{ maxLength: 250 }}
                        disabled ={!this.state.isFromEdit}
                        style={{ marginTop: "0.5vw", width: "38.6vw" }}
                        multiline={true}
                        rows={3}
                        variant="outlined"
                        value={this.state.comments}
                        onChange={(event) => {
                          let value = event.target.value
                          if (value?.length <= 250) {
                            this.setState({ comments: value })
                          } else {
                            this.errorMessage('Allowed only 250 characters')
                          }
                        }}
                      />
                    </div>
                  </Box>
                </Box>
                : null
              }
            </Box>

            <Box>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-end", marginRight: "2vw", marginTop: "1vw" }}>
                <Button
                  sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
                  variant='outlined'
                  onClick={() => { this.handleClear() }}
                >Clear</Button>
                <Button
                  sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                  disabled={this.state.postLoad}
                  variant='contained'
                  onClick={() => {
                    this.setState({postLoad : true},()=>{this.handleValidation()})
                  }}
                >{states.isFromEdit ? "Update" : "Add"}</Button>
              </div>
            </Box>

          </Box>
        </Modal>
      </div>
    )
  }
  gridToolBar = () => {
    var ExportData = []
    this.state.specimenData?.length > 0 && this.state.specimenData?.map((item) => {
      return (
        ExportData?.push({
          "SI.No": item?.sno, "Specimen Code": item?.specimen_code, "Specimen Name": item?.specimen_name, "Container Name": item?.container_name, "Disposable": item?.is_disposable === true ? "Yes" : item?.is_disposable === false ? "No" : "","Status": item?.is_active === true ? "Active" : item?.is_active === false ? "InActive" : "",
        })
      )
    }
    )
    return (
      <Box>
        <CommonGridToolBarWithFilterTextCustom data={ExportData} title={"Specimen Master"} filename={"Specimen Master"} />
      </Box>
    )
  }   

  renderTable = () => {
    this.state.specimenData?.forEach((element, index) => element.sno = index + 1)

    const { t } = this.props
    const columns = [
      {
        field: "sno", flex: 0.03, headerName: t("SNo"), headerAlign: "center", align: "center",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.sno ? params?.row?.sno : "-"}</Box>)
      },
      {
        field: "specimen_code", flex: 0.2, headerName: t("Specimen Code"), headerAlign: "center", align: "center",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.specimen_code ? params?.row?.specimen_code : "-"}</Box>)
      },
      {
        field: "specimen_name", flex: 0.2, headerName: t("Specimen Name"), headerAlign: "left", align: "left",
        renderCell: (params) => (<div>{params?.row?.specimen_name?.length > 25 ?
          <Tooltip placement="top" title={params?.row?.specimen_name} arrow><div>{params?.row?.specimen_name.slice(0, 22) + "..."}</div></Tooltip>
          : params?.row?.specimen_name ? params?.row?.specimen_name : "-"}</div>)
      },
      {
        field: "container_name", flex: 0.2, headerName: t("Container Name"), headerAlign: "left", align: "left",
        renderCell: (params) => (<div>{params?.row?.container_name?.length > 25 ?
          <Tooltip placement="top" title={params?.row?.container_name} arrow><div>{params?.row?.container_name.slice(0, 22) + "..."}</div></Tooltip>
          : params?.row?.container_name ? params?.row?.container_name : "-"}</div>)
      },
      {
        field: "is_disposable", flex: 0.2, headerName: t("Disposable"), headerAlign: "left", align: "left",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.is_disposable ? "Yes" : "No"}</Box>)
      },
      {
        field: "is_active", flex: 0.2, headerName: t("Status"), headerAlign: "left", align: "left",
        renderCell: (params) => {
          return (
            <Tooltip placement="top" title={params?.row?.inactive_reason} arrow><div>{params?.row?.is_active ? "Active" : "Inactive"}</div></Tooltip>  
          )
        }
      },
      {
        field: "action", flex: 0.17, headerName: t("Action"), headerAlign: "center", align: "center", sortable: false,
        renderCell: (params) => <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
          { userAccess?.editAccess ? <Tooltip title={t("Edit")} placement="top" arrow>
            <Button emed_tid="vnd_edit" className='eMed_usrconf_btn' onClick={() => { this.handleEdit(params.row) }} >
              <img src={ImagePaths.Edit.default} alt="print" className='eMed_action_img' />
            </Button>
          </Tooltip> : null }
        </Box>
      }
    ]
    return (
      <Box component={"div"} className='eMed_Purcahse_Table_Container' sx={{ backgroundColor: Colors.Background }}>
        <Stack component={"div"}>
          <Paper className='eMed_Purchase_Table_Wrapper' >
            <DataGrid
              rows={this.state.specimenData}
              columns={columns}
              getRowId={(row) => row['sno']}
              page={this.state.page}
              pageSize={this.state.pageSize}
              hideFooterSelectedRowCount
              localeText={{
                toolbarColumns: "",
                toolbarDensity: "",
                toolbarExport: "",
                toolbarFilters: "",
                toolbarExportPrint: ""
              }}
              headerHeight={40}
              components={{
                Toolbar: this.gridToolBar,
                NoRowsOverlay: () => (
                  <Stack className='eMed_conf_nodata'>
                    {t("NoRecordsFound")}
                  </Stack>
                )
              }}
              loading={this.state.isLoader}
              rowCount={this.state.specimenData?.length}
              onPageChange={(newPage) => { this.setState({ page: newPage }) }}
              onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
              rowsPerPageOptions={[10, 20, 30]}
              pagination
              disableSelectionOnClick
            />
          </Paper>
        </Stack>
      </Box>
    )
  }
  render() {
    const { t } = this.props;
    return (
      <div style={{ backgroundColor: Colors.Background }}>
        <div className='eMed_Purchase_Table_top' style={{ backgroundColor: Colors.Background }}>
          { userAccess?.editAccess ? <><Button emed_tid="add_vnd" className='eMed_Filter_Btns' variant='contained' size='small' onClick={() => { this.setState({ openPopUp: true }) }}>{`Add New Specimen`}</Button>
            <Divider orientation='vertical' /></> : null}
          <Tooltip title="Filter" placement='top' arrow>
            <Button emed_tid="vnd_filter" className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
              <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
            </Button>
          </Tooltip>
        </div>
        {this.renderTable()}
        {this.addNewDepartPopup()}
        <Drawer
          anchor={'right'}
          open={this.state.FilterOpen}
          ModalProps={{ onBackdropClick: this.closeFilter }}
        >
          {this.renderFilterScreen()}
        </Drawer>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}

      </div>
    )
  }
}
export default withTranslation()(SpecimenMaster)






